import type { PropsWithChildren } from 'react';
import { useId } from 'react';

import { VFlex } from '../VFlex';
import VBaseCheckboxRadioContextProvider from './VBaseCheckboxRadioContextProvider';
import style from './style';
import type { VBaseCheckboxRadioProps } from './type';

const VBaseCheckboxRadio = ({
  id,
  children,
  label,
  size = 'md',

  ...rest
}: PropsWithChildren<VBaseCheckboxRadioProps>) => {
  const fallbackId = useId();
  const _id = id ?? fallbackId;
  const _style = style({ ...rest, size });

  return (
    <VBaseCheckboxRadioContextProvider id={_id} {...rest}>
      <VFlex gap={0.25} items="center">
        {children}
        {label && (
          <label htmlFor={_id} className={_style.label}>
            {label}
          </label>
        )}
      </VFlex>
    </VBaseCheckboxRadioContextProvider>
  );
};

export default VBaseCheckboxRadio;
